<script> 
  let uid= Math.random().toString(36).substring(2);
  export let datasrc;
  export let alt;
  export let id;
  export let randomid =true;
  export let style="";
  if(randomid){
  id = id + uid;
  }
  export let css="mx-auto block w-full"; 
  css = css + " lazyload";
    function preloadImage(img) {
      const src = img.getAttribute("data-src");
      if(src){
      img.src = src;
      img.classList.add("opacity-100");
      img.classList.remove("opacity-25");
      img.removeAttribute("data-src");
      }
    }
  function loaded () {

  const images = document.querySelectorAll(".lazyload");
    const config = {
      rootMargin: "0px 0px 50px 0px",
      threshold: 0,
    }; 

    let observer = new IntersectionObserver(function (entries, self) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // console.log(`Image ${entry.target.src} is in the viewport!`);
          preloadImage(entry.target);
          // Stop watching and load the image
          self.unobserve(entry.target);
        }
      });
    }, config);

    images.forEach((image) => {
      observer.observe(image);
    });

  }
</script>

 
<img width="600" height="600" on:load={()=>loaded()}
class="{css} transition-opacity ease-linear duration-500 opacity-25" style="{style}"
data-src={datasrc}  {alt}  {id} src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"/> 